<script lang="ts">
	import { DropType } from '#lib/features/checkout/constants/drop-types.js';
	import { ALL } from '#lib/features/checkout/utils/getCartIconContext/index.js';
	import { DropPageGenerator } from '#lib/features/drop-page/components/DropPageGenerator/index.js';
	import type { DropSections } from '#lib/features/drop-page/constants/dropSectionImports/types.js';
	import { page } from '$app/state';
	import type { ExhibitionsPagePageData } from '$routes/exhibitions/[slug]/types';

	const componentItems = page.data
		.componentItems as ExhibitionsPagePageData['componentItems'];
	// Imported by the route's universal load (`loadDropSections`).
	const dropSections = page.data.dropSections as DropSections;
</script>

<DropPageGenerator
	dropConfigId={null}
	productId={ALL}
	{componentItems}
	sections={dropSections}
	showRegisterCode={null}
	showCardButtons
	showCardCartButton={false}
	pastDropType={DropType.Purchase}
/>
